import { api } from '@/core/lib/api-client';
import { ResendEmailConfirmationDto, ResponseType } from '@link-in-bio/domain';

export const resendEmailConfirmation = ({ email }: ResendEmailConfirmationDto): Promise<ResponseType<void>> => {
  return api.post('/auth/resend-email-confirmation', { email });
};
